/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AddressDto,
    AddressDtoFromJSON,
    AddressDtoFromJSONTyped,
    AddressDtoToJSON,
    FailureCreatorTypes,
    FailureCreatorTypesFromJSON,
    FailureCreatorTypesFromJSONTyped,
    FailureCreatorTypesToJSON,
    PhoneDto,
    PhoneDtoFromJSON,
    PhoneDtoFromJSONTyped,
    PhoneDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface CreateFailuresInGroupCommand
 */
export interface CreateFailuresInGroupCommand {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateFailuresInGroupCommand
     */
    deviceIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateFailuresInGroupCommand
     */
    identifier?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateFailuresInGroupCommand
     */
    reportedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateFailuresInGroupCommand
     */
    closedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateFailuresInGroupCommand
     */
    deadline?: Date;
    /**
     * 
     * @type {AddressDto}
     * @memberof CreateFailuresInGroupCommand
     */
    address?: AddressDto;
    /**
     * 
     * @type {string}
     * @memberof CreateFailuresInGroupCommand
     */
    typeId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateFailuresInGroupCommand
     */
    expanseId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFailuresInGroupCommand
     */
    description1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFailuresInGroupCommand
     */
    natureId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFailuresInGroupCommand
     */
    description2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFailuresInGroupCommand
     */
    optimalDeadlineDaysId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFailuresInGroupCommand
     */
    statusId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFailuresInGroupCommand
     */
    stateChangeReason?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFailuresInGroupCommand
     */
    parentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFailuresInGroupCommand
     */
    contractorId?: string | null;
    /**
     * 
     * @type {FailureCreatorTypes}
     * @memberof CreateFailuresInGroupCommand
     */
    creatorType?: FailureCreatorTypes;
    /**
     * 
     * @type {string}
     * @memberof CreateFailuresInGroupCommand
     */
    notifierFamilyname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFailuresInGroupCommand
     */
    notifierMiddlename?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFailuresInGroupCommand
     */
    notifierForename?: string | null;
    /**
     * 
     * @type {PhoneDto}
     * @memberof CreateFailuresInGroupCommand
     */
    notifierPhone?: PhoneDto;
    /**
     * 
     * @type {string}
     * @memberof CreateFailuresInGroupCommand
     */
    notifierEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFailuresInGroupCommand
     */
    comment?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateFailuresInGroupCommand
     */
    repairmanIds?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFailuresInGroupCommand
     */
    townId?: string | null;
}

export function CreateFailuresInGroupCommandFromJSON(json: any): CreateFailuresInGroupCommand {
    return CreateFailuresInGroupCommandFromJSONTyped(json, false);
}

export function CreateFailuresInGroupCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFailuresInGroupCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'deviceIds': json['deviceIds'],
        'identifier': !exists(json, 'identifier') ? undefined : json['identifier'],
        'reportedAt': !exists(json, 'reportedAt') ? undefined : (new Date(json['reportedAt'])),
        'closedAt': !exists(json, 'closedAt') ? undefined : (json['closedAt'] === null ? null : new Date(json['closedAt'])),
        'deadline': !exists(json, 'deadline') ? undefined : (new Date(json['deadline'])),
        'address': !exists(json, 'address') ? undefined : AddressDtoFromJSON(json['address']),
        'typeId': json['typeId'],
        'expanseId': !exists(json, 'expanseId') ? undefined : json['expanseId'],
        'description1': !exists(json, 'description1') ? undefined : json['description1'],
        'natureId': !exists(json, 'natureId') ? undefined : json['natureId'],
        'description2': !exists(json, 'description2') ? undefined : json['description2'],
        'optimalDeadlineDaysId': !exists(json, 'optimalDeadlineDaysId') ? undefined : json['optimalDeadlineDaysId'],
        'statusId': !exists(json, 'statusId') ? undefined : json['statusId'],
        'stateChangeReason': !exists(json, 'stateChangeReason') ? undefined : json['stateChangeReason'],
        'parentId': !exists(json, 'parentId') ? undefined : json['parentId'],
        'contractorId': !exists(json, 'contractorId') ? undefined : json['contractorId'],
        'creatorType': !exists(json, 'creatorType') ? undefined : FailureCreatorTypesFromJSON(json['creatorType']),
        'notifierFamilyname': !exists(json, 'notifierFamilyname') ? undefined : json['notifierFamilyname'],
        'notifierMiddlename': !exists(json, 'notifierMiddlename') ? undefined : json['notifierMiddlename'],
        'notifierForename': !exists(json, 'notifierForename') ? undefined : json['notifierForename'],
        'notifierPhone': !exists(json, 'notifierPhone') ? undefined : PhoneDtoFromJSON(json['notifierPhone']),
        'notifierEmail': !exists(json, 'notifierEmail') ? undefined : json['notifierEmail'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'repairmanIds': !exists(json, 'repairmanIds') ? undefined : json['repairmanIds'],
        'townId': !exists(json, 'townId') ? undefined : json['townId'],
    };
}

export function CreateFailuresInGroupCommandToJSON(value?: CreateFailuresInGroupCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'deviceIds': value.deviceIds,
        'identifier': value.identifier,
        'reportedAt': value.reportedAt === undefined ? undefined : (value.reportedAt.toISOString()),
        'closedAt': value.closedAt === undefined ? undefined : (value.closedAt === null ? null : value.closedAt.toISOString()),
        'deadline': value.deadline === undefined ? undefined : (value.deadline.toISOString()),
        'address': AddressDtoToJSON(value.address),
        'typeId': value.typeId,
        'expanseId': value.expanseId,
        'description1': value.description1,
        'natureId': value.natureId,
        'description2': value.description2,
        'optimalDeadlineDaysId': value.optimalDeadlineDaysId,
        'statusId': value.statusId,
        'stateChangeReason': value.stateChangeReason,
        'parentId': value.parentId,
        'contractorId': value.contractorId,
        'creatorType': FailureCreatorTypesToJSON(value.creatorType),
        'notifierFamilyname': value.notifierFamilyname,
        'notifierMiddlename': value.notifierMiddlename,
        'notifierForename': value.notifierForename,
        'notifierPhone': PhoneDtoToJSON(value.notifierPhone),
        'notifierEmail': value.notifierEmail,
        'comment': value.comment,
        'repairmanIds': value.repairmanIds,
        'townId': value.townId,
    };
}


